import { Box, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import OrderProductItem from "./OrderProductItem";
import OrderParentComboProduct from "./OrderParentComboProduct";

function groupByParentId(details) {
  const groups = {};
  details.forEach((item) => {
    const key = item?.parent_product_details?.[0]?.id || null;
    if (key) {
      if (!groups[key]) groups[key] = [];
      groups[key].push(item);
    }
  });
  return Object.entries(groups).map(([parent_id, items]) => ({
    parent_id,
    parent_product:
      {
        ...items?.[0]?.parent_product_details?.[0],
        product_quantity: items?.[0]?.product_quantity,
      } || {},
    items,
  }));
}

const ProductDetails = ({ data }) => {
  const baseNormalProducts =
    data?.ordered_products?.filter(
      (p) =>
        (!p.combo_price || Number(p.combo_price) === 0) &&
        !p.parent_product_details?.[0],
    ) || [];

  // ✅ Deduplicate ordered_addons by addon_id (API returns same addon with different order_addons_id)
  const seenAddonIds = new Set();
  const uniqueAddons = (data?.ordered_addons || []).filter((addon) => {
    if (addon.parent_id !== null && addon.parent_id !== undefined) return false; // ✅ skip if has parent_id
    const id = String(addon.addon_id);
    if (seenAddonIds.has(id)) return false;
    seenAddonIds.add(id);
    return true;
  });

  const addonProducts = uniqueAddons.map((addon) => ({
    ...addon,
    order_product_id: addon.order_addons_id,
    product_total: addon.total,
    product_quantity: addon.quantity,
    product_details: [
      {
        product_name: addon.product_name,
        images: [{ app_product_image: addon.image }],
        weight_ids: [{ itemName: "" }],
        unit: { unit_name: "" },
        shape_id: 0,
        photo_cakes_images: [],
      },
    ],
  }));

  const normalProducts = [...baseNormalProducts, ...addonProducts];

  const comboProducts =
    data?.ordered_products?.filter((p) => Number(p.combo_price) > 0) || [];
  const comboGroups = groupByParentId(comboProducts || []);

  return (
    <Box>
      <SectionTitle>Order Contents</SectionTitle>

      <ProductCard>
        <Box sx={{ width: "100%", mx: "auto" }}>
          {comboGroups.map((group, index) => (
            <Box key={group.parent_id}>
              <OrderParentComboProduct
                key={group.parent_id}
                divider={index !== comboGroups.length - 1}
                index={index}
                parentProduct={group?.parent_product}
                childProducts={group.items}
                comboAddons={group.items?.[0]?.combo_addon_details || []}
              />
            </Box>
          ))}
          {normalProducts.map((product, index) => (
            <OrderProductItem
              key={product.order_product_id || index}
              data={product}
              divider={index !== normalProducts.length - 1}
            />
          ))}
        </Box>
      </ProductCard>
    </Box>
  );
};

const SectionTitle = styled(Typography)(() => ({
  fontSize: "18px",
  fontWeight: 700,
  color: "var(--neutral-black)",
  marginBottom: "12px",
  textAlign: "left",
}));

const ProductCard = styled(Box)(() => ({
  border: "1px solid rgba(183, 124, 10, 0.22)",
  borderRadius: "16px",
  padding: "12px",
  background: "linear-gradient(180deg, rgba(255,255,255,0.98) 0%, rgba(255,250,242,0.96) 100%)",
  boxShadow: "0 10px 24px rgba(173, 132, 61, 0.08)",
}));

export default ProductDetails;
